<template>
    <b-card no-body>
        <b-card-header class="p-2">
            <h4 class="mb-0 font-weight-bolder">
                مالی
            </h4>
            <h5 @click="$router.push(`/advanced-sales-report`)" class="mb-0 text-info pointer">
                گزارش جامع
            </h5>
        </b-card-header>
        <hr class="m-0">
        <div class="pl-2">
            <vue-apex-charts :options="options" :series="salesAnalytics.series" />
        </div>
    </b-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { BCard, BButton, BRow, BCol, BCardHeader } from 'bootstrap-vue';
import { $themeColors } from '@themeConfig'
export default {
    name: 'ternaryLineChart',
    components: {
        VueApexCharts,
        BCardHeader,
        BCard,
        BButton,
        BRow,
        BCol
    },
    props: {
        salesAnalytics: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            options: {
                colors: [$themeColors.success, $themeColors.warning, $themeColors.primary],
                yaxis: {
                    labels: {
                        formatter: (value) => {
                            return this.abbreviateNumber(value);
                        },
                        offsetX: -10
                    }
                },
                responsive: [
                    {
                        breakpoint: 768,
                        options: {
                            chart: {
                                height: 330,
                            },
                        }
                    },
                    {
                        breakpoint: 3000,
                        options: {
                            chart: {
                                height: 360,
                            },
                        }
                    }
                ],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shadeIntensity: 1,
                        inverseColors: false,
                        opacityFrom: 0.45,
                        opacityTo: 0.05,
                        stops: [20, 100, 100, 100]
                    },
                },
                chart: {
                    type: 'area',
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    position: 'bottom',
                    horizontalAlign: 'center',
                    floating: false,
                    offsetY: -5,
                    fontSize: '16px',
                },
                stroke: {
                    curve: 'smooth',
                    width: 3
                },
                markers: {
                    size: 0,
                    strokeWidth: 0,
                    hover: {
                        size: 6
                    }
                },
                grid: {
                    show: true,
                    padding: {
                        bottom: 10
                    }
                },
                tooltip: {
                    marker: {
                        show: true,
                    },
                    style: {
                        fontSize: '16px'
                    },
                    y: {
                        formatter: function (value) {
                            return value != null
                                ? value.toLocaleString('fa-IR') + ' ریال'
                                : '';
                        }
                    }
                },
                labels: this.salesAnalytics.labels,
                xaxis: {
                    tooltip: {
                        enabled: false
                    },
                    labels: {
                        style: {
                            fontSize: '13px',
                        }
                    }
                },
            },

        }
    },
    methods: {
        abbreviateNumber(value) {
            if (value == null) return '';
            const abs = Math.abs(value);
            const units = [
                { value: 1e9, symbol: 'B' },
                { value: 1e6, symbol: 'M' },
                { value: 1e3, symbol: 'K' }
            ];
            for (let i = 0; i < units.length; i++) {
                if (abs >= units[i].value) {
                    const formatted = (value / units[i].value)
                        .toFixed(1)
                        .replace(/\.0$/, '');
                    return units[i].symbol + ' ' + formatted;
                }
            }
            return value.toString();
        }
    }
}
</script>